import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { defaultLocale, localeCookie } from '../constants';
import Cookies from 'js-cookie';

const checkLocale = (locale: string): string | undefined => {
  const supportedLngs = i18n.options?.supportedLngs as string[] | false | undefined;

  if (!Array.isArray(supportedLngs) || supportedLngs.length === 0) {
    return undefined;
  }

  if (supportedLngs.includes(locale)) {
    return locale;
  }

  // Try to find a supported locale by language code (e.g., 'en' -> 'en-US')
  const [language] = locale.split('-');
  return supportedLngs.find(lng => lng.startsWith(`${language}-`));
};

export const buildCustomLanguageDetector = () => {
  const customLanguageDetector = new LanguageDetector();
  customLanguageDetector.addDetector({
    name: 'customDetector',
    lookup(): string | undefined {
      const detectedLanguage =
        new URL(window.location.href).searchParams.get('lng') ||
        Cookies.get(localeCookie) ||
        localStorage.getItem('i18nextLng');
      if (detectedLanguage && checkLocale(detectedLanguage)) {
        return checkLocale(detectedLanguage);
      } else if (navigator.languages.length) {
        for (let locale of navigator.languages) {
          if (checkLocale(locale)) {
            return checkLocale(locale);
          }
        }
      }

      return defaultLocale;
    }
  });

  return customLanguageDetector;
};
